import { useEffect, useState } from "react";
import {
  Image,
  Row,
  Col,
  Button,
  Modal,
  Table,
  Alert,
} from "react-bootstrap";

export function RequiredMappingsModal(props)  {

  const [requiredMappingsData, setRequiredMappingsData] = useState([]);

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  useEffect(() => {
    if (props.flowId){
      fetch(`${process.env.REACT_APP_BASE_URI}/workflow/mapping/required/${props.flowId}/`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            // logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        // console.log("FIRM JOBS: ", data["data"])
        setRequiredMappingsData(data["data"]);
      });
    }
    
  }, [props.flowId]);

  return (
    <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    backdrop="static"
    centered
    className="mapping-modal"
    scrollable="false"
>
    <Modal.Header className="mapping-modal-header" closeButton>
    <div> <h5> Required Mappings </h5> <br></br>
     <p style={{ color: 'blue' }}> <i> Click Add to add/edit the mappings. </i></p>
     </div>
    </Modal.Header>
    <Modal.Body className="mapping-modal">
      <br></br>  <hr></hr>
   

  <Table striped bordered hover>
        <thead>
            <tr>
            <th>#</th>
              <th>{props.sourceVendor}</th>
              <th>{props.destinationVendor}</th>
            </tr>
            <tr>
              <th>#</th>
              <th>What is it called in {props.sourceVendor}?</th>
              <th>What is it called in {props.destinationVendor}?</th>
            </tr>
          </thead>
          <tbody>
            {/* <tr>
              <td>1</td>
              <td>Mark</td>
              <td>Otto</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Jacob</td>
              <td>Thornton</td>
            </tr> */}

            {requiredMappingsData.length > 0 ? (
                  requiredMappingsData.map((mapping, index) => (
                    <tr key={index}>
                      <td>{index+1}</td>
                      <td>{mapping}?</td> {/* Adjust this based on the actual structure of your data */}
                      <td>{mapping}</td> {/* Adjust this based on the actual structure of your data */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="1">No mappings available.</td>
                </tr>
          )}

        </tbody>
    </Table>

    </Modal.Body>
    <Modal.Footer className="action-footer">
        
    </Modal.Footer>
  </Modal>
  )
}
